export default "__VITE_ASSET__CG6JQ8XT__"